import { requestGooseAPI, getAPIPath } from '../shared/request'
import { CLIENT_LOCATION_INVOICES_PATH, CLIENT_CANCEL_INVOICE_PATH } from '../types/constants'
import { APIInvoiceClientDtoResponse, OrderClientDto } from '../types/api'
import { TInvoiceListOptions } from '../types/general'

export const ClientInvoiceService = {
  cancelInvoice: (locationId: string, orderId: string, invoiceId: string): Promise<OrderClientDto> => {
    return requestGooseAPI<OrderClientDto>({
      url: getAPIPath(CLIENT_CANCEL_INVOICE_PATH, { locationId, orderId, invoiceId }),
      method: 'PUT',
    })
  },

  getList: (locationId: string, options: TInvoiceListOptions): Promise<APIInvoiceClientDtoResponse> => {
    const { includes = [], ...rest } = options
    const includesList = new Set()
    includes.forEach((i) => includesList.add(i))
    const includeShared = options.hasSharedCRM

    if (options.hasSharedCRM) {
      includesList.add('location.delegateLocation')
    }

    return requestGooseAPI<APIInvoiceClientDtoResponse>({
      url: getAPIPath(CLIENT_LOCATION_INVOICES_PATH, { locationId }),
      method: 'GET',
      params: {
        ...rest,
        includes: [...includesList],
        includeShared,
      },
    })
  },
}
